import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

export interface FrontWindshieldProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontWindshield(props: FrontWindshieldProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Windshield"
      width={238}
      height={414}
      viewBox="0 0 238 414"
      position={{top: 44, left: 357}}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35 2.1528C40 1.15488 54 0.155645 68 2.1528C96.9801 6.28696 172 35.1292 236 49.1186C229.667 64.4238 217 112.004 217 179.081V234.919C217 301.996 229.667 349.576 236 364.881C172 378.871 96.9801 407.713 68 411.847C54 413.844 40 412.845 35 411.847C23.6667 390.22 1.00008 324.807 1 240.164V173.837C1 89.1933 23.6667 23.7796 35 2.1528ZM65.8584 9.54245C51.896 6.53555 48.9041 6.53585 41.9229 22.5727C32.565 44.0692 13.0001 105.765 13 163.9V250.1C13.0001 308.235 32.565 369.931 41.9229 391.427C48.9041 407.464 51.896 407.464 65.8584 404.457C82.6928 400.832 175.46 370.942 199.501 365.367C212.466 362.36 220.182 355.394 217.453 340.309C215.458 329.284 210.088 302.221 206.482 255.112C205.485 242.082 198.687 240.788 192.52 237.07C187.533 234.063 186.536 228.048 186.536 225.041V188.958C186.536 185.952 187.533 179.937 192.52 176.93C198.687 173.211 205.485 171.918 206.482 158.888C210.088 111.779 215.458 84.7164 217.453 73.6909C220.182 58.6059 212.466 51.6402 199.501 48.6333C175.46 43.0576 82.6928 13.1679 65.8584 9.54245Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        opacity="0.8"
        d="M186.536 225.042V207V188.958C186.536 185.951 187.533 179.937 192.52 176.93C198.687 173.212 205.485 171.919 206.482 158.889C210.088 111.779 215.458 84.7168 217.453 73.6912C220.182 58.606 212.466 51.6402 199.501 48.6332C175.46 43.0576 82.693 13.1681 65.8586 9.54266C51.8959 6.5357 48.9039 6.5357 41.9226 22.5728C32.5647 44.0693 13 105.766 13 163.9V207V250.1C13 308.234 32.5647 369.931 41.9226 391.427C48.9039 407.464 51.8959 407.464 65.8586 404.457C82.693 400.832 175.46 370.942 199.501 365.367C212.466 362.36 220.182 355.394 217.453 340.309C215.458 329.283 210.088 302.221 206.482 255.111C205.485 242.081 198.687 240.788 192.52 237.07C187.533 234.063 186.536 228.049 186.536 225.042Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M217 234.92C217 301.996 229.667 349.576 236 364.881C172 378.871 96.9801 407.713 68 411.847C54 413.844 40 412.845 35 411.847C23.6667 390.22 1 324.807 1 240.163L1 207L1 173.837C1 89.1928 23.6667 23.7797 35 2.15286C40 1.15494 54 0.155701 68 2.15286C96.9801 6.28702 172 35.1294 236 49.1188C229.667 64.424 217 112.004 217 179.08V207V234.92Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M186.536 225.042V207V188.958C186.536 185.951 187.533 179.937 192.52 176.93C198.687 173.212 205.485 171.919 206.482 158.889C210.088 111.779 215.458 84.7168 217.453 73.6912C220.182 58.606 212.466 51.6402 199.501 48.6332C175.46 43.0576 82.693 13.1681 65.8586 9.54266C51.8959 6.5357 48.9039 6.5357 41.9226 22.5728C32.5647 44.0693 13 105.766 13 163.9V207V250.1C13 308.234 32.5647 369.931 41.9226 391.427C48.9039 407.464 51.8959 407.464 65.8586 404.457C82.693 400.832 175.46 370.942 199.501 365.367C212.466 362.36 220.182 355.394 217.453 340.309C215.458 329.283 210.088 302.221 206.482 255.111C205.485 242.081 198.687 240.788 192.52 237.07C187.533 234.063 186.536 228.049 186.536 225.042Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="4.09899"
        height="72.882"
        rx="1"
        transform="matrix(0.999346 0.0361722 -0.0370264 0.999314 26.6987 257.627)"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></rect>
      <rect
        width="4.09899"
        height="72.882"
        rx="1"
        transform="matrix(0.999346 0.0361722 -0.0370264 0.999314 26.6985 257.627)"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M32.9929 346.958L35.3655 348L37 346.541L33.4149 275.255L35.2074 273.119L34.7329 258.371L32.3077 256.652L28.3008 184.115L24.452 184.688L28.248 256.235C27.6329 257.034 26.3922 258.684 26.35 258.892C26.3078 259.101 26.7542 268.741 26.9827 273.535L29.1443 275.255L32.9929 346.958Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <rect
        width="8.17356"
        height="18.1097"
        rx="2"
        transform="matrix(0.998729 -0.0504049 0.0515937 0.998668 26.2967 257.089)"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M24.5029 185.205C24.4744 184.654 24.8984 184.184 25.45 184.156L27.5463 184.05C28.0978 184.023 28.5681 184.447 28.5966 184.999L32.3053 256.786L28.2116 256.993L24.5029 185.205Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M29.1459 275.078L33.2396 274.872C34.6907 302.959 35.5118 318.853 36.9479 346.651C36.9764 347.202 36.5528 347.68 36.0012 347.708L33.9049 347.814C33.3533 347.842 32.8831 347.417 32.8546 346.866L29.1459 275.078Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="4.04067"
        height="43.5071"
        rx="1"
        transform="matrix(0.977765 0.209704 -0.208702 0.977979 24.257 123.688)"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></rect>
      <rect
        width="4.04067"
        height="43.5071"
        rx="1"
        transform="matrix(0.977765 0.209704 -0.208702 0.977979 24.2571 123.687)"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M14.042 193.898L16.0912 194.751H16.6766L18.0338 194.325L26.7625 142.141H27.5077L29.1576 141.02L31.5261 125.52L30.1689 124.4L41 61.758L40.3879 60.5307L37.7533 60.0772L36.8485 60.5307L26.1505 123.546L23.9151 124.4L21.3071 137.899V140.434L22.9038 141.474L14.042 193.898Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M36.7811 60.9866C36.8716 60.4418 37.3866 60.0738 37.9313 60.1647L39.944 60.5007C40.4887 60.5916 40.857 61.107 40.7665 61.6518L30.3549 124.338L26.3695 123.673L36.7811 60.9866Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M22.7872 141.428L26.7726 142.093L18.1491 194.014C18.0586 194.558 17.5437 194.926 16.9989 194.835L14.9863 194.499C14.4415 194.409 14.0733 193.893 14.1638 193.348L22.7872 141.428Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="8.05705"
        height="18.1031"
        rx="2"
        transform="matrix(0.986353 0.164646 -0.163846 0.986486 23.8889 123.258)"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
